import * as React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  DialogContentText,
  Button
} from '@material-ui/core/';

import ButtonClose from "../../../../../../../../../../../util/buttonClose/.mixins/buttonClose";

//css
import StylesCss from './styles';
const useStyles = StylesCss();

export default ({
    open,
    handlerEntendido,
    handlerClose,
}) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={handlerClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      align={"center"}
    >
      <div className={classes.root}>
        <Typography>
          ESCOLHA A NOVA OPÇÃO DE PAGAMENTO
          <ButtonClose closeMethod={handlerClose}/>
        </Typography>
        <DialogContent>
          <DialogContentText>
            Opções de pagamento definidas com sucesso!
          </DialogContentText>
          <DialogContentText>
            <b>A nova data de pagamento já está registrada em nosso sistema.</b>
          </DialogContentText>
          <DialogContentText>
            Você pode alterar a opção de recebimento até 1 dia antes da data agendada de entrega.
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classes.buttonActions}>
          <Button
            variant={"contained"}
            color={"primary"}
            onClick={handlerEntendido}
          >
            ENTENDIDO
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
};
